import React from 'react';
import { Typography, Box, Button } from '@mui/joy';

function EmptyMessageComponent({ title, description, actionText, actionHandler }: any) {

    return (
        <Box sx={{
            textAlign: 'center',
            padding: 4,
            maxWidth: 400,
            margin: '0 auto'
        }}>
            <Typography
                level="title-lg"
                sx={{
                    marginBottom: 2,
                    fontWeight: 600,
                    color: 'neutral.700'
                }}>
                {title}
            </Typography>
            <Typography
                level="body-sm"
                sx={{
                    color: 'neutral.500',
                    lineHeight: 1.6
                }}>
                {description}
            </Typography>
            {actionText && actionHandler && (
                <Box sx={{ marginTop: 3 }}>
                    <Button
                        color={'primary'}
                        size='sm'
                        variant={'solid'}
                        onClick={actionHandler}
                        sx={{ mt: 2 }}>
                        {actionText}
                    </Button>
                </Box>
            )}
        </Box>
    );
}

export default EmptyMessageComponent;